module.exports = __webpack_public_path__ + "static/media/iwatch.cb452018.png";